export class TireChoiceType {
    static MINE = 'mine';
    static BUY = 'buy';
}

Object.freeze(TireChoiceType);